import { render, staticRenderFns } from "./GroupsTuiTree.vue?vue&type=template&id=5c8124a0&"
import script from "./GroupsTuiTree.vue?vue&type=script&lang=ts&"
export * from "./GroupsTuiTree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports